import React, { FC } from 'react'
import styles from 'styles/components/modal.module.scss'

type Props = {
  title: string
}

const ConfirmModalTitle: FC<Props> = (props) => {
  const { title } = props
  return <h3 className={styles.confirm__title}>{title}</h3>
}

export default ConfirmModalTitle
